module.exports = __webpack_public_path__ + "static/media/tara_kaviani.c5686aa7.png";